import Vue from "vue";
import Vuex from 'vuex';
import * as getters from "./getters";
import * as actions from "./action";
import * as mutations from "./mutations";
Vue.use(Vuex);
var state = {
  resName: '圣能'
};
var store = new Vuex.Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});
export default store;